import React from "react";

export const initialAlert = {
  showAction: false,
  onAlertClick: () => {},
  actionButtonLabel: null,
};

export const initialOrganizeState = {
  activeSelectedMediaType: "",
  alert: initialAlert,
  currentCollectionContentList: [],
  dragAction: "",
  dragSourceId: null,
  dragSourceParent: { id: null, name: null },
  dropItems: [],
  dropTarget: {},
  dropHandler: () => {},
  includeDialog: {
    open: false,
    activeType: null,
    action: "",
    selected: [],
  },
  selectedContent: [],
  selectedContentGroups: [],
};

export const OrganizeContext = React.createContext(initialOrganizeState);
